import cn from 'clsx';
import * as styles from './styles.css';

import { UIText1, UIText2 } from '@cian/ui-kit';

export interface IButtons<V> {
  label: string;
  value: V;
}

export interface IButtonGroupProps<V> {
  buttons: IButtons<V>[];
  currentActiveValue?: V;
  onChange(value: V): void;
  fullWidth?: boolean;
  testId?: string;
  isValuationView?: boolean;
}

export const ButtonGroup = <V,>({
  buttons,
  currentActiveValue,
  onChange,
  fullWidth,
  testId,
  isValuationView,
}: IButtonGroupProps<V>) => {
  return (
    <div className={styles['container']} data-name={testId}>
      <div>
        {buttons.map(({ label, value }, index) => {
          const TextComponent = isValuationView ? UIText2 : UIText1;

          return (
            <button
              key={index}
              type="button"
              onClick={() => onChange(value)}
              className={cn(
                styles['button'],
                value === currentActiveValue && styles['active'],
                isValuationView && styles['valuation'],
                fullWidth && styles['button-equal-grow'],
              )}
            >
              <TextComponent>{label}</TextComponent>
            </button>
          );
        })}
      </div>
    </div>
  );
};
